// extracted by mini-css-extract-plugin
export var fullHeightState = "_23-7";
export var headerCell = "_23-1";
export var loadingStateCell = "_23-4";
export var rowWrapper = "_23-3";
export var standaloneTable = "_23-8";
export var standaloneTableWithBodyFill = "_23-9";
export var stateCell = "_23-5";
export var table = "_23-0";
export var tableBodyFiller = "_23-6";
export var white = "_23-2";